/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFallRiskLow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 2h2v3.5l1.59 1.193 3.513 2.51L18 11.518V16h-2v-3.52l-1.307-1.045-3.389 4.66L10 17.832V21H8v-3.833l1.086-1.448-2.253-1.61-2.191.731-1.81 2.715-1.664-1.11 2.19-3.285 3.022-1.007 3.232-4.444L8 6.5zm3.226 6.89-2.824 3.882 1.872 1.338 2.824-3.882zM16 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm7 14v-4h2v4zm2 3h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFallRiskLow as FallRiskLow };
